module.exports = __webpack_public_path__ + "static/img/ny-06-VIDEO.a24bc7b0.jpg";